import React, { useEffect, useState } from 'react'
import { BreadCrumbsAndTitle } from '../../components/generics/BreadCrumbsAndTitle'
import { hasPemissions } from '../../commons/utils';
import { Button, Divider } from '@mui/material';
import { AlertsInformativos } from '../../components/generics/AlertsInformativos';
import { alertInformativo } from '../../commons/texts';
import { mtDividerUpTable } from '../../commons';
import { CreateDialogExpressCheckin } from '../../components/modals/checkingExpress/CreateDialogExpressCheckin';
import { CodigosExpresCheckingTable } from '../../components/tables/CodigosExpresCheckingTable';
// import { ExpressCheckinTable } from '../../components/tables/ExpressCheckinTable';
// import { ExpressCheckinTable } from '../../components/tables/ExpressCheckinTable';

export const CodigosExpressCheckin = () => {

    // USE STATE 
      const [modalCreate, setModalCreate] = useState(false);
      const [canCreate, setCanCreate]     = useState<boolean>(false);
    
    
    
        // USE EFFECT 
        useEffect(() => {
          hasPrmissionsCreate();
        }, []);
      
      
        // CONST FUNCTIONS 
        const hasPrmissionsCreate = async() => {
    
          const hasPermissions = await hasPemissions('modulo.hotel', 'modulo.codigosexpresscheckin', 'create' );
    
          if ( hasPermissions ) {
                setCanCreate(true);
          }
    
        }
    
    
      // FUNCTIONS OPEN MODALS 
      const openModal = () => {
         setModalCreate(true);
      }
    
      const handleCloseModalCrear = () => {
         setModalCreate(false);
      } 



  return (
    <div>


        <BreadCrumbsAndTitle
                    title="Listado Codigos Express Checkin" 
                    mainModule="hotel" 
                    parent="Listado Codigos Express Checkin"
                    action="" />

        {
           canCreate && <div style={{ display: 'flex', justifyContent: 'end'}}>
                          <Button  variant='contained' sx={{ marginBottom: 3 }} onClick={openModal}>Crear Codigo</Button>
                        </div>
        }  

        <AlertsInformativos type={'info'} title={'info'} content={alertInformativo.codigosexpressChecking} />
        <Divider sx={{ marginBottom: mtDividerUpTable }}/>
        <CreateDialogExpressCheckin open={modalCreate} handleCloseModalCrear={handleCloseModalCrear} />

        <CodigosExpresCheckingTable/>

    </div>
  )
}

// expressCheckin